var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBack28(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.884 4.116a1.25 1.25 0 0 1 0 1.768l-5.787 6.822c-.524.618-.786.927-.786 1.294s.262.676.786 1.294l5.787 6.822a1.25 1.25 0 0 1-1.768 1.768l-7.055-7.056c-1.334-1.333-2-2-2-2.828 0-.828.666-1.495 2-2.828l7.055-7.056a1.25 1.25 0 0 1 1.768 0Z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack28);
export default __webpack_public_path__ + "static/media/back_28.6ee545c3.svg";
export { ForwardRef as ReactComponent };